import React from 'react'
import './styles.scss'

const color = {
  ONLINE: '#1FB082',
  OFFLINE: '#D8D8D8',
  ABSENT: '#FF983B',
}

const StatusPoint = (props) => {
  const { status = 'ONLINE', className = '' } = props
  return (
    <div
      className={`status-point-container ${className}`}
      style={{
        backgroundColor: color[status]
      }}
    />
  )
}

export default StatusPoint